module.exports = (event) => {
  event = event || window.event

  if (event.stopPropagation) {
    event.stopPropagation()
  }

  if (event.preventDefault) {
    event.preventDefault()
  }

  event.cancelBubble = true
  event.returnValue = false

  return false
}
